import React from 'react';
import PropTypes from 'prop-types';
import ReactPhoneInput from 'react-phone-input-2';
import { e164PhoneFormatter } from 'common/formatters/PhoneNumber';
import classNames from 'classnames';

export class CountryPhoneInput extends React.Component {
  static propTypes = {
    inputExtraProps: PropTypes.object,
  };

  static defaultProps = {
    placeholder: '(___) ___ - ____',
  };

  componentDidMount() {
    // try to initialize value as valid e164 number
    const e164_value = e164PhoneFormatter(
      this.props.input.value,
      gon.current_store.cart_tax_country_iso
    );
    this.props.input.onChange(e164_value);
  }

  render() {
    const {
      input: { value, onChange, onBlur },
      meta: { touched, error },
    } = this.props;
    let inputClass = 'intl-text Field__input';
    if (this.props.disabled) inputClass += ' Field__input--disabled';
    const buttonClass = classNames({ 'is-disabled': this.props.disabled });
    const defaultCountry = gon.current_store.cart_tax_country_iso.toLowerCase();

    return (
      <div>
        <ReactPhoneInput
          onBlur={onBlur}
          onChange={onChange}
          defaultCountry={defaultCountry}
          preferredCountries={[defaultCountry]}
          disableAreaCodes={true}
          enableLongNumbers={true}
          inputClass={inputClass}
          containerClass={'react-tel-input Field--country-phone'}
          buttonClass={buttonClass}
          value={value}
          placeholder={this.props.placeholder}
          inputExtraProps={{ name: 'phone', ...this.props.inputExtraProps }}
          disabled={this.props.disabled}
        />
        {touched && error && <div className="Field__error">{error}</div>}
      </div>
    );
  }
}
